import { AnyDocument } from '../../../../types';
import { DocumentParams } from '../../../documents/types/DocumentParams';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const getApplicationQueryKey = <DocumentType extends AnyDocument>(
  documentId: DocumentType['id'],
  documentParams: DocumentParams,
) => [APPLICATION_BASE_PATH, 'document', documentId, documentParams];
